import { useState, useMemo } from 'react';
import { useEditorStore } from '../../store/editorStore';

// ── Curated Font Awesome icon catalogue ──────────────────────

const ICON_CATEGORIES = [
  'All', 'Popular', 'Social', 'Arrows', 'Media', 'Business',
  'Shopping', 'Weather', 'Travel', 'Health', 'Tech', 'Food',
  'Emoji', 'Design', 'Communication',
];

const ICONS = [
  // Popular
  { label: 'Heart', class: 'fa-solid fa-heart', category: 'Popular' },
  { label: 'Star', class: 'fa-solid fa-star', category: 'Popular' },
  { label: 'Fire', class: 'fa-solid fa-fire', category: 'Popular' },
  { label: 'Lightning', class: 'fa-solid fa-bolt', category: 'Popular' },
  { label: 'Crown', class: 'fa-solid fa-crown', category: 'Popular' },
  { label: 'Trophy', class: 'fa-solid fa-trophy', category: 'Popular' },
  { label: 'Gem', class: 'fa-solid fa-gem', category: 'Popular' },
  { label: 'Sparkles', class: 'fa-solid fa-wand-magic-sparkles', category: 'Popular' },
  { label: 'Thumbs Up', class: 'fa-solid fa-thumbs-up', category: 'Popular' },
  { label: 'Check', class: 'fa-solid fa-circle-check', category: 'Popular' },
  { label: 'X Mark', class: 'fa-solid fa-circle-xmark', category: 'Popular' },
  { label: 'Info', class: 'fa-solid fa-circle-info', category: 'Popular' },
  { label: 'Warning', class: 'fa-solid fa-triangle-exclamation', category: 'Popular' },
  { label: 'Clock', class: 'fa-solid fa-clock', category: 'Popular' },
  { label: 'Calendar', class: 'fa-solid fa-calendar-days', category: 'Popular' },
  { label: 'Bookmark', class: 'fa-solid fa-bookmark', category: 'Popular' },
  { label: 'Tag', class: 'fa-solid fa-tag', category: 'Popular' },
  { label: 'Pin', class: 'fa-solid fa-thumbtack', category: 'Popular' },
  { label: 'Link', class: 'fa-solid fa-link', category: 'Popular' },
  { label: 'Quote Left', class: 'fa-solid fa-quote-left', category: 'Popular' },
  { label: 'Quote Right', class: 'fa-solid fa-quote-right', category: 'Popular' },

  // Social
  { label: 'Instagram', class: 'fa-brands fa-instagram', category: 'Social' },
  { label: 'Facebook', class: 'fa-brands fa-facebook', category: 'Social' },
  { label: 'X / Twitter', class: 'fa-brands fa-x-twitter', category: 'Social' },
  { label: 'YouTube', class: 'fa-brands fa-youtube', category: 'Social' },
  { label: 'TikTok', class: 'fa-brands fa-tiktok', category: 'Social' },
  { label: 'LinkedIn', class: 'fa-brands fa-linkedin', category: 'Social' },
  { label: 'WhatsApp', class: 'fa-brands fa-whatsapp', category: 'Social' },
  { label: 'Pinterest', class: 'fa-brands fa-pinterest', category: 'Social' },
  { label: 'Snapchat', class: 'fa-brands fa-snapchat', category: 'Social' },
  { label: 'Spotify', class: 'fa-brands fa-spotify', category: 'Social' },
  { label: 'Telegram', class: 'fa-brands fa-telegram', category: 'Social' },
  { label: 'Discord', class: 'fa-brands fa-discord', category: 'Social' },
  { label: 'Reddit', class: 'fa-brands fa-reddit', category: 'Social' },
  { label: 'Twitch', class: 'fa-brands fa-twitch', category: 'Social' },
  { label: 'GitHub', class: 'fa-brands fa-github', category: 'Social' },
  { label: 'Dribbble', class: 'fa-brands fa-dribbble', category: 'Social' },
  { label: 'Behance', class: 'fa-brands fa-behance', category: 'Social' },
  { label: 'Figma', class: 'fa-brands fa-figma', category: 'Social' },
  { label: 'Threads', class: 'fa-brands fa-threads', category: 'Social' },
  { label: 'Medium', class: 'fa-brands fa-medium', category: 'Social' },

  // Arrows
  { label: 'Arrow Up', class: 'fa-solid fa-arrow-up', category: 'Arrows' },
  { label: 'Arrow Down', class: 'fa-solid fa-arrow-down', category: 'Arrows' },
  { label: 'Arrow Left', class: 'fa-solid fa-arrow-left', category: 'Arrows' },
  { label: 'Arrow Right', class: 'fa-solid fa-arrow-right', category: 'Arrows' },
  { label: 'Chevron Up', class: 'fa-solid fa-chevron-up', category: 'Arrows' },
  { label: 'Chevron Down', class: 'fa-solid fa-chevron-down', category: 'Arrows' },
  { label: 'Chevron Left', class: 'fa-solid fa-chevron-left', category: 'Arrows' },
  { label: 'Chevron Right', class: 'fa-solid fa-chevron-right', category: 'Arrows' },
  { label: 'Circle Arrow Up', class: 'fa-solid fa-circle-arrow-up', category: 'Arrows' },
  { label: 'Circle Arrow Down', class: 'fa-solid fa-circle-arrow-down', category: 'Arrows' },
  { label: 'Angles Up', class: 'fa-solid fa-angles-up', category: 'Arrows' },
  { label: 'Angles Down', class: 'fa-solid fa-angles-down', category: 'Arrows' },
  { label: 'Share', class: 'fa-solid fa-share', category: 'Arrows' },
  { label: 'Reply', class: 'fa-solid fa-reply', category: 'Arrows' },
  { label: 'Rotate', class: 'fa-solid fa-rotate', category: 'Arrows' },
  { label: 'Swipe Up', class: 'fa-solid fa-hand-pointer', category: 'Arrows' },

  // Media
  { label: 'Play', class: 'fa-solid fa-play', category: 'Media' },
  { label: 'Pause', class: 'fa-solid fa-pause', category: 'Media' },
  { label: 'Play Circle', class: 'fa-solid fa-circle-play', category: 'Media' },
  { label: 'Camera', class: 'fa-solid fa-camera', category: 'Media' },
  { label: 'Video', class: 'fa-solid fa-video', category: 'Media' },
  { label: 'Music', class: 'fa-solid fa-music', category: 'Media' },
  { label: 'Headphones', class: 'fa-solid fa-headphones', category: 'Media' },
  { label: 'Microphone', class: 'fa-solid fa-microphone', category: 'Media' },
  { label: 'Image', class: 'fa-solid fa-image', category: 'Media' },
  { label: 'Film', class: 'fa-solid fa-film', category: 'Media' },
  { label: 'Podcast', class: 'fa-solid fa-podcast', category: 'Media' },
  { label: 'Volume High', class: 'fa-solid fa-volume-high', category: 'Media' },

  // Business
  { label: 'Briefcase', class: 'fa-solid fa-briefcase', category: 'Business' },
  { label: 'Chart Line', class: 'fa-solid fa-chart-line', category: 'Business' },
  { label: 'Chart Bar', class: 'fa-solid fa-chart-simple', category: 'Business' },
  { label: 'Chart Pie', class: 'fa-solid fa-chart-pie', category: 'Business' },
  { label: 'Money Bill', class: 'fa-solid fa-money-bill-wave', category: 'Business' },
  { label: 'Dollar', class: 'fa-solid fa-dollar-sign', category: 'Business' },
  { label: 'Building', class: 'fa-solid fa-building', category: 'Business' },
  { label: 'Users', class: 'fa-solid fa-users', category: 'Business' },
  { label: 'User', class: 'fa-solid fa-user', category: 'Business' },
  { label: 'Handshake', class: 'fa-solid fa-handshake', category: 'Business' },
  { label: 'Lightbulb', class: 'fa-solid fa-lightbulb', category: 'Business' },
  { label: 'Rocket', class: 'fa-solid fa-rocket', category: 'Business' },
  { label: 'Target', class: 'fa-solid fa-bullseye', category: 'Business' },
  { label: 'Award', class: 'fa-solid fa-award', category: 'Business' },

  // Shopping
  { label: 'Cart', class: 'fa-solid fa-cart-shopping', category: 'Shopping' },
  { label: 'Bag', class: 'fa-solid fa-bag-shopping', category: 'Shopping' },
  { label: 'Store', class: 'fa-solid fa-store', category: 'Shopping' },
  { label: 'Gift', class: 'fa-solid fa-gift', category: 'Shopping' },
  { label: 'Percent', class: 'fa-solid fa-percent', category: 'Shopping' },
  { label: 'Tags', class: 'fa-solid fa-tags', category: 'Shopping' },
  { label: 'Barcode', class: 'fa-solid fa-barcode', category: 'Shopping' },
  { label: 'Credit Card', class: 'fa-solid fa-credit-card', category: 'Shopping' },
  { label: 'Receipt', class: 'fa-solid fa-receipt', category: 'Shopping' },
  { label: 'Box', class: 'fa-solid fa-box', category: 'Shopping' },
  { label: 'Truck', class: 'fa-solid fa-truck-fast', category: 'Shopping' },

  // Weather
  { label: 'Sun', class: 'fa-solid fa-sun', category: 'Weather' },
  { label: 'Moon', class: 'fa-solid fa-moon', category: 'Weather' },
  { label: 'Cloud', class: 'fa-solid fa-cloud', category: 'Weather' },
  { label: 'Cloud Sun', class: 'fa-solid fa-cloud-sun', category: 'Weather' },
  { label: 'Rain', class: 'fa-solid fa-cloud-rain', category: 'Weather' },
  { label: 'Snow', class: 'fa-solid fa-snowflake', category: 'Weather' },
  { label: 'Wind', class: 'fa-solid fa-wind', category: 'Weather' },
  { label: 'Temperature', class: 'fa-solid fa-temperature-half', category: 'Weather' },
  { label: 'Umbrella', class: 'fa-solid fa-umbrella', category: 'Weather' },
  { label: 'Rainbow', class: 'fa-solid fa-rainbow', category: 'Weather' },

  // Travel
  { label: 'Location', class: 'fa-solid fa-location-dot', category: 'Travel' },
  { label: 'Map', class: 'fa-solid fa-map', category: 'Travel' },
  { label: 'Globe', class: 'fa-solid fa-globe', category: 'Travel' },
  { label: 'Plane', class: 'fa-solid fa-plane', category: 'Travel' },
  { label: 'Car', class: 'fa-solid fa-car', category: 'Travel' },
  { label: 'Train', class: 'fa-solid fa-train', category: 'Travel' },
  { label: 'Ship', class: 'fa-solid fa-ship', category: 'Travel' },
  { label: 'Compass', class: 'fa-solid fa-compass', category: 'Travel' },
  { label: 'Mountain', class: 'fa-solid fa-mountain-sun', category: 'Travel' },
  { label: 'Hotel', class: 'fa-solid fa-hotel', category: 'Travel' },
  { label: 'Passport', class: 'fa-solid fa-passport', category: 'Travel' },
  { label: 'Suitcase', class: 'fa-solid fa-suitcase-rolling', category: 'Travel' },

  // Health
  { label: 'Heart Pulse', class: 'fa-solid fa-heart-pulse', category: 'Health' },
  { label: 'Dumbbell', class: 'fa-solid fa-dumbbell', category: 'Health' },
  { label: 'Running', class: 'fa-solid fa-person-running', category: 'Health' },
  { label: 'Apple', class: 'fa-solid fa-apple-whole', category: 'Health' },
  { label: 'Yoga', class: 'fa-solid fa-spa', category: 'Health' },
  { label: 'Stethoscope', class: 'fa-solid fa-stethoscope', category: 'Health' },
  { label: 'Pills', class: 'fa-solid fa-pills', category: 'Health' },
  { label: 'Brain', class: 'fa-solid fa-brain', category: 'Health' },

  // Tech
  { label: 'Laptop', class: 'fa-solid fa-laptop', category: 'Tech' },
  { label: 'Mobile', class: 'fa-solid fa-mobile-screen', category: 'Tech' },
  { label: 'Desktop', class: 'fa-solid fa-desktop', category: 'Tech' },
  { label: 'Code', class: 'fa-solid fa-code', category: 'Tech' },
  { label: 'WiFi', class: 'fa-solid fa-wifi', category: 'Tech' },
  { label: 'Robot', class: 'fa-solid fa-robot', category: 'Tech' },
  { label: 'Microchip', class: 'fa-solid fa-microchip', category: 'Tech' },
  { label: 'Database', class: 'fa-solid fa-database', category: 'Tech' },
  { label: 'Cloud Upload', class: 'fa-solid fa-cloud-arrow-up', category: 'Tech' },
  { label: 'Shield', class: 'fa-solid fa-shield-halved', category: 'Tech' },
  { label: 'Lock', class: 'fa-solid fa-lock', category: 'Tech' },
  { label: 'QR Code', class: 'fa-solid fa-qrcode', category: 'Tech' },

  // Food
  { label: 'Utensils', class: 'fa-solid fa-utensils', category: 'Food' },
  { label: 'Coffee', class: 'fa-solid fa-mug-hot', category: 'Food' },
  { label: 'Wine Glass', class: 'fa-solid fa-wine-glass', category: 'Food' },
  { label: 'Pizza', class: 'fa-solid fa-pizza-slice', category: 'Food' },
  { label: 'Burger', class: 'fa-solid fa-burger', category: 'Food' },
  { label: 'Ice Cream', class: 'fa-solid fa-ice-cream', category: 'Food' },
  { label: 'Cake', class: 'fa-solid fa-cake-candles', category: 'Food' },
  { label: 'Martini', class: 'fa-solid fa-martini-glass', category: 'Food' },
  { label: 'Beer', class: 'fa-solid fa-beer-mug-empty', category: 'Food' },
  { label: 'Lemon', class: 'fa-solid fa-lemon', category: 'Food' },

  // Emoji / Faces
  { label: 'Smile', class: 'fa-solid fa-face-smile', category: 'Emoji' },
  { label: 'Laugh', class: 'fa-solid fa-face-laugh', category: 'Emoji' },
  { label: 'Wink', class: 'fa-solid fa-face-laugh-wink', category: 'Emoji' },
  { label: 'Love', class: 'fa-solid fa-face-kiss-wink-heart', category: 'Emoji' },
  { label: 'Cool', class: 'fa-solid fa-face-grin-stars', category: 'Emoji' },
  { label: 'Sad', class: 'fa-solid fa-face-sad-tear', category: 'Emoji' },
  { label: 'Surprise', class: 'fa-solid fa-face-surprise', category: 'Emoji' },
  { label: 'Angry', class: 'fa-solid fa-face-angry', category: 'Emoji' },
  { label: 'Think', class: 'fa-solid fa-face-meh', category: 'Emoji' },
  { label: 'Tears of Joy', class: 'fa-solid fa-face-laugh-squint', category: 'Emoji' },

  // Design / Creative
  { label: 'Palette', class: 'fa-solid fa-palette', category: 'Design' },
  { label: 'Pen', class: 'fa-solid fa-pen', category: 'Design' },
  { label: 'Brush', class: 'fa-solid fa-paintbrush', category: 'Design' },
  { label: 'Pencil', class: 'fa-solid fa-pencil', category: 'Design' },
  { label: 'Eye', class: 'fa-solid fa-eye', category: 'Design' },
  { label: 'Scissors', class: 'fa-solid fa-scissors', category: 'Design' },
  { label: 'Ruler', class: 'fa-solid fa-ruler', category: 'Design' },
  { label: 'Swatchbook', class: 'fa-solid fa-swatchbook', category: 'Design' },
  { label: 'Crop', class: 'fa-solid fa-crop-simple', category: 'Design' },
  { label: 'Wand', class: 'fa-solid fa-wand-magic-sparkles', category: 'Design' },
  { label: 'Layer Group', class: 'fa-solid fa-layer-group', category: 'Design' },
  { label: 'Vector', class: 'fa-solid fa-bezier-curve', category: 'Design' },

  // Communication
  { label: 'Envelope', class: 'fa-solid fa-envelope', category: 'Communication' },
  { label: 'Phone', class: 'fa-solid fa-phone', category: 'Communication' },
  { label: 'Comment', class: 'fa-solid fa-comment', category: 'Communication' },
  { label: 'Comments', class: 'fa-solid fa-comments', category: 'Communication' },
  { label: 'Bell', class: 'fa-solid fa-bell', category: 'Communication' },
  { label: 'Megaphone', class: 'fa-solid fa-bullhorn', category: 'Communication' },
  { label: 'Paper Plane', class: 'fa-solid fa-paper-plane', category: 'Communication' },
  { label: 'At', class: 'fa-solid fa-at', category: 'Communication' },
  { label: 'Hashtag', class: 'fa-solid fa-hashtag', category: 'Communication' },
  { label: 'Signal', class: 'fa-solid fa-signal', category: 'Communication' },
];

// ── Component ────────────────────────────────────────────────

export default function IconsPanel() {
  const [search, setSearch] = useState('');
  const [activeCategory, setActiveCategory] = useState('All');
  const activePageId = useEditorStore((s) => s.activePageId);
  const story = useEditorStore((s) => s.story);
  const addLayer = useEditorStore((s) => s.addLayer);

  const filtered = useMemo(() => {
    let list = ICONS;
    if (activeCategory !== 'All') {
      list = list.filter((i) => i.category === activeCategory);
    }
    if (search.trim()) {
      const q = search.toLowerCase();
      list = list.filter(
        (i) =>
          i.label.toLowerCase().includes(q) ||
          i.class.toLowerCase().includes(q) ||
          i.category.toLowerCase().includes(q),
      );
    }
    return list;
  }, [search, activeCategory]);

  function handleAdd(icon) {
    if (!activePageId || !story) return;
    addLayer(
      activePageId,
      {
        type: 'icon',
        iconClass: icon.class,
        color: '#ffffff',
        fontSize: 48,
      },
      { x: 30, y: 30, width: 40, height: 40, rotation: 0, opacity: 1 },
    );
  }

  return (
    <div className="flex flex-col h-full">
      {/* Search */}
      <div className="p-2 shrink-0">
        <input
          type="text"
          placeholder="Search icons..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full rounded-md border px-2.5 py-1.5 text-xs outline-none"
          style={{
            background: 'var(--t-surface)',
            borderColor: 'var(--t-border)',
            color: 'var(--t-text)',
          }}
        />
      </div>

      {/* Category pills */}
      <div
        className="flex gap-1 px-2 pb-2 flex-wrap shrink-0"
        style={{ maxHeight: 70, overflowY: 'auto' }}
      >
        {ICON_CATEGORIES.map((cat) => (
          <button
            key={cat}
            onClick={() => setActiveCategory(cat)}
            className="text-[10px] font-medium px-2 py-0.5 rounded-full border transition-colors"
            style={{
              background: activeCategory === cat ? 'var(--brand-primary)' : 'transparent',
              color: activeCategory === cat ? '#fff' : 'var(--t-muted)',
              borderColor: activeCategory === cat ? 'var(--brand-primary)' : 'var(--t-border)',
              cursor: 'pointer',
            }}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* Count */}
      <div className="px-2 pb-1 shrink-0">
        <span className="text-[10px]" style={{ color: 'var(--t-muted)' }}>
          {filtered.length} icons
        </span>
      </div>

      {/* Icon Grid */}
      <div className="flex-1 overflow-y-auto px-2 pb-2">
        <div className="grid grid-cols-4 gap-1">
          {filtered.map((icon) => (
            <button
              key={icon.class}
              onClick={() => handleAdd(icon)}
              title={icon.label}
              className="flex flex-col items-center justify-center gap-1 rounded-lg border transition-all"
              style={{
                padding: '8px 2px 6px',
                background: 'var(--t-panel)',
                borderColor: 'var(--t-border)',
                cursor: 'pointer',
                minHeight: 56,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'var(--t-panel2)';
                e.currentTarget.style.borderColor = 'rgba(99,102,241,0.5)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'var(--t-panel)';
                e.currentTarget.style.borderColor = 'var(--t-border)';
              }}
            >
              <i
                className={icon.class}
                style={{ fontSize: 20, color: 'var(--t-text)', lineHeight: 1 }}
              />
              <span
                className="text-center leading-tight truncate w-full"
                style={{ fontSize: 9, color: 'var(--t-muted)' }}
              >
                {icon.label}
              </span>
            </button>
          ))}
        </div>

        {filtered.length === 0 && (
          <div className="flex items-center justify-center py-8">
            <span className="text-xs" style={{ color: 'var(--t-muted)' }}>
              No icons found
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
